module.exports = __webpack_public_path__ + "static/media/DrumofEndurance.e2e5de06.png";